import React from 'react';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className="
        min-h-screen
        w-full
        flex
        flex-col
        bg-auth-gradient
      "
    >
      {/* Main Content */}
      <div
        className="
          flex-1
          flex
          items-center
          justify-center
          px-4
          py-10
        "
      >
        <div
          className="
            w-[350px]
            max-md:w-full
            max-md:max-w-[90%]
            mx-auto
          "
        >
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <footer
        className="
          w-full
          bg-footer-bg
          text-body-inverse
          border-t
          border-white-soft
          px-4
          py-3
        "
      >
        <div className="grid md:grid-cols-3 items-center gap-3">
          {/* Left */}
          <div
            className="
              flex
              flex-wrap
              items-center
              gap-4
              text-xs
              md:text-sm
              font-semibold
              max-md:justify-center
            "
          >
            <span
              className="
                cursor-pointer
                hover:text-primary
                transition-all
                duration-300
              "
            >
              Terms and Conditions
            </span>

            <span
              className="
                cursor-pointer
                hover:text-primary
                transition-all
                duration-300
              "
            >
              Responsible Gaming
            </span>
          </div>

          {/* Center */}
          <div
            className="
              flex
              items-center
              justify-center
              text-lg
              md:text-2xl
              font-bold
              text-card
            "
          >
            24X7 Support
          </div>

          {/* Right */}
          <div />
        </div>
      </footer>
    </div>
  );
}